import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21 9c0 1.495-.602 3.222-1.689 5.164-.675 1.208-1.527 2.476-2.514 3.778a53.653 53.653 0 0 1-3.512 4.159l-.395.418-.89.904-.818-.83-.467-.492-.463-.503-.246-.272a53.646 53.646 0 0 1-2.803-3.384c-.987-1.302-1.839-2.57-2.514-3.778C3.602 12.222 3 10.494 3 9c0-5.28 4.13-9 9-9s9 3.72 9 9Zm-8.494 10.99a51.732 51.732 0 0 0 2.697-3.257c.935-1.233 1.737-2.426 2.363-3.545C18.5 11.517 19 10.084 19 9c0-4.126-3.19-7-7-7S5 4.874 5 9c0 1.084.5 2.517 1.434 4.188.626 1.12 1.428 2.312 2.363 3.545.685.904 1.412 1.79 2.146 2.633l.551.624.506.556.506-.556Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconActionPinLine24 = createIcon(IconComponent);